module.exports = __webpack_public_path__ + "img/QQ-&-Augmented-Reality-Marketing.ac1f47fe.png";